import { useEffect, type RefObject } from 'react'

/**
 * Tutup dropdown saat klik di luar elemen — tanpa overlay `fixed inset-0`
 * (yang rusak kalau parent-nya ada CSS transform, mis. hover lift).
 */
export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T | null>,
  onOutside: () => void,
  active: boolean,
) {
  useEffect(() => {
    if (!active) return
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onOutside()
    }
    // pointerdown menangkap sebelum click, lebih responsif
    document.addEventListener('pointerdown', handler)
    return () => document.removeEventListener('pointerdown', handler)
  }, [ref, onOutside, active])
}
